import { atom, getDefaultStore } from 'jotai'

const store = getDefaultStore()

export const favoritesChannelAtom = atom(0)
export const blockedRelaysChannelAtom = atom(0)
export const blossomChannelAtom = atom(0)
export const inboxChannelAtom = atom(0)
export const outboxChannelAtom = atom(0)
export const searchRelaysChannelAtom = atom(0)
export const simpleGroupsChannelAtom = atom(0)
export const muteListChannelAtom = atom(0)
export const feedChannelAtom = atom(0)
export const metadataChannelAtom = atom(0)
export const repliesChannelAtom = atom(0)
export const followListChannelAtom = atom(0)
export const relayListChannelAtom = atom(0)
export const pinListChannelAtom = atom(0)
export const emojiListChannelAtom = atom(0)
export const favoriteFollowSetsChannelAtom = atom(0)
export const relayMembershipsChannelAtom = atom(0)

export function invalidateFavorites() {
  store.set(favoritesChannelAtom, (v) => v + 1)
}
export function invalidateBlockedRelays() {
  store.set(blockedRelaysChannelAtom, (v) => v + 1)
}
export function invalidateBlossom() {
  store.set(blossomChannelAtom, (v) => v + 1)
}
export function invalidateInbox() {
  store.set(inboxChannelAtom, (v) => v + 1)
}
export function invalidateOutbox() {
  store.set(outboxChannelAtom, (v) => v + 1)
}
export function invalidateSearchRelays() {
  store.set(searchRelaysChannelAtom, (v) => v + 1)
}
export function invalidateSimpleGroups() {
  store.set(simpleGroupsChannelAtom, (v) => v + 1)
}
export function invalidateMuteList() {
  store.set(muteListChannelAtom, (v) => v + 1)
}
export function invalidateFeed() {
  store.set(feedChannelAtom, (v) => v + 1)
}
export function invalidateMetadata() {
  store.set(metadataChannelAtom, (v) => v + 1)
}
export function invalidateReplies() {
  store.set(repliesChannelAtom, (v) => v + 1)
}
export function invalidateFollowList() {
  store.set(followListChannelAtom, (v) => v + 1)
}
export function invalidateRelayList() {
  store.set(relayListChannelAtom, (v) => v + 1)
}
export function invalidatePinList() {
  store.set(pinListChannelAtom, (v) => v + 1)
}
export function invalidateEmojiList() {
  store.set(emojiListChannelAtom, (v) => v + 1)
}
export function invalidateFavoriteFollowSets() {
  store.set(favoriteFollowSetsChannelAtom, (v) => v + 1)
}
export function invalidateRelayMemberships() {
  store.set(relayMembershipsChannelAtom, (v) => v + 1)
}
